import {
  changeCity,
  changeMetadata,
  saveOrder,
  selectCity,
  selectOrderId,
  selectPoint,
} from '@entities/cart';
import { apiDelivery } from '@entities/delivery';
import { useEffect, useState } from 'react';
import xhr from '@shared/config/api';
import { useAppDispatch, useAppSelector } from '@shared/hooks';
import type { CDEKCity, CDEKPickupPoint } from '@shared/types/delivery';

export const useDelivery = () => {
  const dispatch = useAppDispatch();
  const [cityLoading, setCityLoading] = useState<string>('idle');
  const [city, setCity] = useState<string>('');
  const [cityList, setCityList] = useState<CDEKCity[]>([]);

  const [pointsLoading, setPointsLoading] = useState<string>('idle');
  const [pickupPoints, setPickupPoints] = useState<CDEKPickupPoint[]>([]);

  const orderId = useAppSelector(selectOrderId);
  const savedCity = useAppSelector(selectCity);
  const savedPoint = useAppSelector(selectPoint);
  // console.log("cityList:",cityList);
  useEffect(() => {
    //  запрашиваем города

    const getCities = async (city: string) => {
      setCityLoading('loading');
      try {
        const response = await xhr.get(`${apiDelivery}/cdek/city/?title=${city}`);
        const cities = [...response.data];
        // console.log("cities:",cities);
        setCityList(cities);
      } catch (error) {}
      setCityLoading('loaded');
    };

    if (city) {
      getCities(city);
    } else {
      setCityList([]);
    }
  }, [city]);

  useEffect(() => {
    // запрашиваем точки выдачи

    const getPickupPoints = async (code: { city_code: number }) => {
      setPointsLoading('loading');
      try {
        const response = await xhr.post(`${apiDelivery}/cdek/city/get_points/`, code);
        const points = [...response.data];
        // points = points.filter(
        //   (e, i) => points.findIndex((a) => a.address === e.address || a.phone === e.phone) === i
        // );
        setPickupPoints(points);
      } catch (error) {}
      setPointsLoading('loaded');
    };

    setPickupPoints([] as CDEKPickupPoint[]);

    // if (!city && savedCity) setCity(savedCity.title);
    // console.log("savedCity:",savedCity);
    if (savedCity) {
      getPickupPoints({ city_code: savedCity.code });
    }
  }, [savedCity, dispatch]);

  const saveCity = async (city: CDEKCity) => {
    const from = 438; // код Ростова-на-Дону
    dispatch(changeCity(city));

    try {
      const response = await xhr.post(`${apiDelivery}/cdek/city/calc_delivery/`, {
        from_location: from,
        to_location: city.code,
        order: orderId,
        delivery_sum: 0,
      });
      if (!response.data) {
        throw response;
      }
      dispatch(changeMetadata(response.data as any));
    } catch (error) {}
  };

  const savePoint = (point: CDEKPickupPoint) => {
    dispatch(
      saveOrder({
        carrier: 'C',
        pickup_point: point.code,
      })
    );
  };

  return {
    city,
    setCity,
    cityList,
    pickupPoints,
    cityLoading,
    pointsLoading,
    saveCity,
    savePoint,
    selectedCity: savedCity,
    selectedPoint: savedPoint,
  };
};
